// Centralised logger.
// Today: delegates to console.* in all environments (catch-block diagnostics).
// Tomorrow: swap to Sentry / DataDog / no-op-in-prod by editing only this file.
const isDev = process.env.NODE_ENV !== "production";

export const logger = {
    warn: (...args) => { if (isDev) console.warn(...args); },
    error: (...args) => { if (isDev) console.error(...args); },
};

export default logger;
